export const CONTACT = {
  company: "Fluton Global Metalcraft FZCO",
  phone: "+971 50 268 1816",
  phoneHref: "tel:+971502681816",
  whatsapp: "https://wa.me/971502681816",
  address:
    "Building A1, Dubai Digital Park, International Freezone, Dubai Silicon Oasis, Dubai, United Arab Emirates",
  sister: "Ollexo Group of Companies — India",
};

export const products = [
  {
    name: "Aluminium 6063 Scrap",
    spec: "ISRI Taint / Tabor · 97%+ Al",
    img: "/assets/product-alu6063.jpeg",
    blurb:
      "Clean, uncoated extrusion-grade 6063 scrap — the flagship of our export line, baled and container-ready.",
  },
  {
    name: "Used Beverage Can (UBC) Scrap",
    spec: "ISRI Taldon · Baled",
    img: "/assets/product-ubc.jpeg",
    blurb:
      "Densified, contamination-free UBC bales sourced for can-sheet remelt and closed-loop recycling programs.",
  },
  {
    name: "Aluminium Wire Scrap",
    spec: "ISRI Talon · EC Grade",
    img: "/assets/product-wire.jpeg",
    blurb:
      "Bright EC-grade aluminium wire and cable scrap, stripped and sorted for direct remelt applications.",
  },
  {
    name: "Aluminium Extrusion Scrap",
    spec: "10-10 / 60-40 Mixes",
    img: "/assets/product-extrusion.jpg",
    blurb:
      "Painted and unpainted extrusion offcuts, segregated by alloy and supplied to rolling and extrusion mills.",
  },
  {
    name: "TT Aluminium Scrap",
    spec: "Mixed Sheet · Sorted",
    img: "/assets/product-tt.jpg",
    blurb:
      "Mixed new and old aluminium sheet, magnetically separated and quality-checked before dispatch.",
  },
  {
    name: "Aluminium Foil Scrap",
    spec: "ISRI Terse · Low Ink",
    img: "/assets/product-foil.png",
    blurb:
      "Clean, low-ink aluminium foil scrap pressed into high-density bales for remelt and de-inking plants.",
  },
  {
    name: "Aluminium 6063 Ingot",
    spec: "Remelt-Ready · 7kg / 22kg",
    img: "/assets/product-ingot.avif",
    blurb:
      "Secondary 6063 ingots cast to specification — consistent chemistry, full assay reports on every lot.",
  },
];

export const chapters = [
  {
    no: "01",
    title: "Verified Quality",
    text: "Every consignment is inspected, assayed and photographed before it ships. ISRI-graded material, full documentation, zero surprises at discharge.",
  },
  {
    no: "02",
    title: "Dubai Logistics Hub",
    text: "Operating from Dubai Silicon Oasis with Jebel Ali connectivity, we move containers to Asia, Europe and Africa faster than anyone in the trade.",
  },
  {
    no: "03",
    title: "Transparent Trading",
    text: "LME-linked pricing, clear contracts and honest settlement terms. Our counterparties know exactly what they are buying — and what it costs.",
  },
  {
    no: "04",
    title: "Circular by Design",
    text: "We keep metal in the loop and out of landfill. Trade with us is a direct contribution to the circular economy your customers now demand.",
  },
];

export const stats = [
  { value: 25, suffix: "+", label: "Countries Served" },
  { value: 10000, suffix: "+", label: "Tons Traded Annually" },
  { value: 98, suffix: "%", label: "On-Time Dispatch" },
  { value: 2, suffix: "", label: "Offices — Dubai & India" },
];

export const testimonials = [
  {
    quote:
      "Working with the team has been a smooth experience. Professional, transparent in pricing and operations, and backed by real expertise and integrity.",
    client: "Tata Motors",
    tag: "Trustworthy & Transparent",
  },
  {
    quote:
      "We have been associated for over a year for our metal scrap requirements. Timely collection, transparent dealing, and a genuine commitment to sustainability.",
    client: "Jainam Industries Pvt. Ltd.",
    tag: "Reliable Partner",
  },
  {
    quote:
      "A remarkable job in recycling used beverage cans into valuable resources. Cooperative, knowledgeable, and every transaction is transparent and efficient.",
    client: "Jindal Aluminium",
    tag: "Sustainable Recycling",
  },
];

export const industries = [
  {
    title: "Smelters & Remelters",
    text: "Consistent, assay-verified feedstock for secondary aluminium smelting and remelt operations.",
  },
  {
    title: "Extrusion & Rolling Mills",
    text: "Alloy-segregated 6063 and extrusion scrap delivered to spec for billet and sheet production.",
  },
  {
    title: "Foundries & Die Casting",
    text: "Clean, low-impurity scrap and ingots that keep melt loss low and casting quality high.",
  },
  {
    title: "Automotive Manufacturing",
    text: "Certified recycled metal streams supporting OEM lightweighting and sustainability targets.",
  },
  {
    title: "Packaging & Can Making",
    text: "Closed-loop UBC supply for can-sheet producers building circular packaging programs.",
  },
  {
    title: "Construction & Infrastructure",
    text: "Recycled aluminium and copper feedstock for the region's fastest-growing skylines.",
  },
];

export const process = [
  {
    no: "01",
    title: "Enquiry & Quotation",
    text: "Share your grade, volume and destination. We respond within one business day with an LME-linked offer.",
  },
  {
    no: "02",
    title: "Inspection & QC",
    text: "Material is inspected, weighed and assayed. Photos, videos and third-party survey reports on request.",
  },
  {
    no: "03",
    title: "Documentation & Logistics",
    text: "Export docs, certificates of origin, and container loading supervised from our Dubai hub.",
  },
  {
    no: "04",
    title: "Delivery & Settlement",
    text: "Tracked shipment to your port with transparent settlement against agreed terms.",
  },
];
